import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

const SearchLayout = ({
  children,
  showLogo,
  showSearch,
  isResults,
  showTab,
  showAlphabet,
  searchAnimation,
  PlaceHolder,
  placeholderWords,
  enableSuggestions,
  enableFiltering,
  enableSearchTracking,
  SearchAsYouType,
  showCategoryDropdownProp,
  showDropdownProp,
}) => {
  return (
    <div className="container-fluid flex flex-col bg-pl_bg_light_3 dark:bg-pl_bg_dark_1 justify-between min-h-screen">
      <Header
        showLogo={showLogo}
        showSearch={showSearch}
        showTab={showTab}
        showAlphabet={showAlphabet}
        PlaceHolder={PlaceHolder}
        enableFiltering={enableFiltering}
        enableSearchTracking={enableSearchTracking}
        enableSuggestions={enableSuggestions}
        SearchAsYouType={SearchAsYouType}
        showCategoryDropdownProp={showCategoryDropdownProp}
        showDropdownProp={showDropdownProp}
        placeholderWords={placeholderWords}
        searchAnimation={searchAnimation}
      />

      <main
        className={` ${
          isResults ? "xl:ml-[220px] xl:w-[100vw-220px]" : "w-full"
        } mb-40`}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default SearchLayout;
